import React from 'react';
import Dashboard from './Dashboard';

const UploadData: React.FC = () => {
  return <Dashboard />;
};

export default UploadData;
